<template>
  <div>

    <van-tabs v-model="activeName">

      <van-tab style="margin-top:15px; padding-left:15px" title="Neler Yapıldı ?" name="0">
        <van-pull-refresh v-model="isLoading" @refresh="kayitgetir">
          <div v-for="(item,index) in posts" :key="index" >
          <van-swipe-cell>
            <template #left>
              <van-button square text="Silin" @click="kaldir(item.id)" type="danger" class="delete-button" /> 
            </template>
            <van-panel :title="item.islem" :desc="$helper.trtgoster(item.tarih)+'-'+item.saat">
          </van-panel>
          </van-swipe-cell>
          </div>
        
          </van-pull-refresh>
      </van-tab>

      <van-tab style="margin-top:15px; padding-left:15px" title="İşlem Seç" name="1">
        <van-sticky :offset-top="50">
          <van-field v-model="value1" left-icon="filter-o" placeholder="Yaz, seç veya kaydet" />
        </van-sticky>

        <van-pull-refresh v-model="isLoading" @refresh="islemgetir"> 
          <van-swipe-cell v-for="(item,index) in filteredList" :key="index">
          <van-cell :title="item.alias"/>
            <template #right>
              <van-button text="Seçin" @click="onConfirm(item.alias)"  type="primary" class="delete-button" /> 
            </template>
          </van-swipe-cell>
        </van-pull-refresh>
        <van-button size="large" @click="yeniekle()" type="danger">YENİ EKLE</van-button>
      </van-tab>

    </van-tabs>
        
        <div style="height:70px"></div>
        <van-tabbar v-model="active">
          <van-tabbar-item name="servis" to="/servis" icon="wap-home-o">Servis</van-tabbar-item>
          <van-tabbar-item name="detay" :to="`/servis/${id*8589}`" icon="home-o">Genel</van-tabbar-item>
          <van-tabbar-item name="islem" :to="`/islem/${id*8589}`" icon="notes-o">İşlem</van-tabbar-item>
          <van-tabbar-item name="stok" :to="`/stok/${id*8589}`" icon="points">Stok</van-tabbar-item>
          <van-tabbar-item name="matbuu" :to="`/matbuu/${id*8589}`" icon="photo-o">Matbuu</van-tabbar-item>
          <van-tabbar-item name="cihaz" :to="`/cihaz/${id*8589}`" icon="fire-o">Cihaz</van-tabbar-item>
        </van-tabbar>
<van-popup v-model="show"><van-loading type="spinner" color="#fff" /></van-popup>
  </div>
</template>

<script>
import { Toast } from 'vant';

export default {
  data() {
    return {
      id:this.$route.params.id / 8589,
      error:[],
      active:'islem',
      value: '',
      columns: [],
      showPicker: false,
      ayar:this.$request.ayar(),
      show : false,
      posts:[],
     isLoading: false,
     list:[],
     activeName:1,
     value1:'',
     gid:'',

    };
  },
   computed:{
    filteredList() {
      return this.list.filter(post => {
        return post.alias.toLowerCase().includes(this.value1.toLowerCase())
      })
    }    
  },
  created(){
  this.islemgetir() 
  this.kayitgetir();
  //this.konum2();
  },
  methods: {
        kaldir(id){
          this.show = true
          this.$request.get("servis/logsil/"+id)
          .then(res => {
            this.kayitgetir()
          })
        },
        islemgetir(){
          this.show = true
            this.gid = this.$store.getters.getaktifservis.altkod
            this.$request.get("servis/servisislem/"+this.ayar.firmaid+"/"+this.gid)
            .then(res => { 
              this.list = res.results
            })
            
          },
        kayitgetir(){
          this.show = true
          this.$request.get("servis/log/"+this.id+"/100")
          .then(res => {
            this.posts = res.results;
            this.show = false;
            this.isLoading=false;
          })
        },


    onConfirm(value) {
     this.konum().then(res => {
        this.show = true
        let log ={
        servis_id : this.id,
        tarih: new Date(),
        saat :this.$helper.trsaatyazdir(),
        sd:100,
        kid:this.ayar.kid,
        islem: value,
        enlem:res.lat,
        boylam:res.long
        }
          this.$request.post("servis/servis_log/",log)
            .then(()=> {this.kayitgetir()
            Toast("Eklendi")
            })
          }) 
     
    },
    yeniekle(){
      let data = {
        alias : this.value1,
        gid:this.gid,
        firma:this.ayar.firmaid
      }
      if (data.alias){
        this.$request.post("servis/servisislem",data)
        .then(res=> {
        this.onConfirm(res.mesaj)
      })
      }
      else{Toast("Arama alanı boş")}

    },
    konum(){
      return new Promise((resolve, reject) => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
              resolve({
                  long:position.coords.longitude,
                  lat:position.coords.latitude
              })
            },
            // işlemleri kitlememek için reject göndermedik
            (error) => {
              resolve({
                  long:0,
                  lat:0
              })              
              //alert(error.message);
            }, {
                    enableHighAccuracy: true
                    , timeout: 5000
                }
            );
        } 
        // işlemleri kitlememek için reject göndermedik
        else { 
              resolve({
                  long:0,
                  lat:0
              })            
          //alert("Geolocation is not supported by this browser.");
             }
      })
    },


  },
 
};
</script>


// WEBPACK FOOTER //
// src/components/servis/islem.vue